/**
 * Checks if the origin is a development environment
 * @return {boolean} true if the origin is a development environment
 */
export function checkIsDevelopmentOrigin() {
  const origin = window.location.origin;
  return (
    origin.includes('vfs.cloud9') ||
    origin.includes('localhost') ||
    origin.includes('githubpreview.dev') ||
    origin.includes('54.') ||
    origin.includes('127.0.0.1') ||
    origin.includes('github.dev') ||
    origin.includes('192.168')
  );
}

/**
 * Checks if the origin is an internal environment
 * @return {boolean} true if the origin is an internal environment
 */
export function checkIsInternalOrigin() {
  const hostname = window.location.hostname;
  return (
    hostname.startsWith('dev.katapultpro') ||
    hostname.startsWith('rc.katapultpro') ||
    hostname.startsWith('main.katapultpro') ||
    (hostname.includes('beta-katapult-pro') && hostname.includes('web.app'))
  );
}

/**
 * Checks if the origin is a from chrome extension
 * @return {boolean} true if the origin is from a chrome extension
 */
export function checkIsChromeExtensionOrigin() {
  const origin = window.location.origin;
  return origin.startsWith('chrome-extension://');
}

/**
 * Checks if the origin is a preview channel environment
 * @return {boolean} true if the origin is a preview channel environment
 */
export function checkIsPreviewChannelOrigin() {
  const hostname = window.location.hostname;
  return hostname.endsWith('.web.app') && hostname.includes('--');
}

/**
 * Checks if the origin is a legacy environment
 * @return {boolean} true if the origin is a legacy environment
 */
export function checkIsLegacyOrigin() {
  const hostname = window.location.hostname;
  return hostname.startsWith('legacy.');
}

/**
 * Checks if the origin is a beta environment
 * @return {boolean} true if the origin is a beta environment
 */
export function checkIsBetaOrigin() {
  const hostname = window.location.hostname;
  return hostname.startsWith('beta.') || hostname.startsWith('rc.katapultpro');
}

/**
 * Checks if the origin is an alpha environment
 * @return {boolean} true if the origin is an alpha environment
 */
export function checkIsAlphaOrigin() {
  const hostname = window.location.hostname;
  return hostname.startsWith('alpha.') || hostname.startsWith('dev.katapultpro');
}

/**
 * Get's the "version name" from the origin
 * @return {'alpha'|'beta'|'release'|'legacy'} the version name
 */
export function getVersionNameFromOrigin() {
  if (checkIsAlphaOrigin()) return 'alpha';
  if (checkIsBetaOrigin()) return 'beta';
  if (checkIsLegacyOrigin()) return 'legacy';
  return 'release';
}
